import { Injectable, signal } from '@angular/core';
import { Observable, of } from '@totvs/mingle/node_modules/rxjs';
import { map } from '@totvs/mingle/node_modules/rxjs/operators';
import { TokenService } from './../token/token.service';
import { User } from './user';
import { PoMenuItem } from '@po-ui/ng-components/lib';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  beneficiaryName = signal<string>(this.getBeneficiaryName());
  authorizedMenus: any;
  loginDetails: any;
  accessToken: any;
  client: any;
  beneficiaries: any;

  constructor(private tokenService: TokenService) {}

  getUser(): Observable<User> {
    return of(this.tokenService.getToken()['muser']).pipe(
      map((user) => ({
        name: user?.login,
      })),
    );
  }

  getAuthorizedMenus() {
    return this.tokenService.getToken()['menus'];
  }

  getLoginDetails() {
    return this.tokenService.getToken()['loginDetails'];
  }

  getAccessToken(): Observable<any> {
    return this.tokenService.getToken()['access_token'];
  }

  getClient(): Observable<any> {
    return this.tokenService.getToken()['client'];
  }

  getBeneficiaryName(): string {
    const token = this.tokenService?.getToken();

    return token?.currentUser?.name ?? '';
  }

  getProfileBeneficiaryName(): Observable<any> {
    return of(this.tokenService.getToken()['currentUser']).pipe(
      map((user) => ({
        name: user?.name,
      })),
    );
  }

  getBeneficiary(): Observable<any> {
    return this.tokenService.getToken()['currentUser'];
  }

  getBeneficiaryType(): string {
    return this.tokenService.getToken()['currentUser']['subscriberType'];
  }

  isHolder(): boolean {
    return this.tokenService.getToken()['currentUser']['subscriberType'] == 'T';
  }

  getBeneficiaryId(): string {
    return this.tokenService.getToken()['currentUser']['subscriberId'];
  }

  getBeneficiaries(): Observable<any>[] {
    return this.tokenService.getToken()['beneficiaries'];
  }

  setCurrentUser(selectedBeneficiary: any) {
    this.tokenService.addValue('currentUser', selectedBeneficiary);
    this.beneficiaryName.set(this.getBeneficiaryName());
  }

  // os novos menus devem ser cadastrados nesse array, e devem ser o mesmo link cadastrado no protheus ( rotas )

  getRegisteredMenus(): Array<PoMenuItem> {
    const registeredMenus: Array<PoMenuItem> = [
      {
        label: 'Meu Plano',
        icon: 'an an-credit-card',
        shortLabel: 'Meu Plano',
        subItems: [
          { label: 'Buscar Credenciados', link: 'accrediteds' },
          { label: 'Carteirinha', link: 'digital-card' },
          { label: 'Gerenciar Beneficiários', link: 'beneficiaries' },
          { label: 'Solicitar Cancelamento', link: 'cancel-plan' },
          { label: 'Elegibilidade', link: 'eligibility' },
          { label: 'Informações Cadastrais', link: 'beneficiary-data' },
        ],
      },
      {
        label: 'Serviços',
        icon: 'an an-handshake',
        shortLabel: 'Serviços',
        subItems: [
          { label: 'Boleto', link: 'bank-slips' },
          { label: 'Demonstrativo do IRPF', link: 'income-tax' },
          {
            label: 'Quitação Anual de Débitos',
            link: 'stmt-anual-debts',
          },
          { label: 'Autorizar Procedimentos', link: 'authorization' },
        ],
      },
      {
        label: 'Reembolso',
        icon: 'an an-currency-circle-dollar',
        shortLabel: 'Reembolso',
        subItems: [
          { label: 'Solicitar Reembolso', link: 'refund-request' },
          { label: 'Status Reembolso', link: 'refund-status' },
        ],
      },
      {
        label: 'Extratos',
        icon: 'an an-newspaper-clipping',
        shortLabel: 'Extratos',
        subItems: [
          { label: 'Extrato de Utilização', link: 'stmt-utilization' },
          { label: 'Extrato Financeiro', link: 'stmt-finance' },
        ],
      },
    ];
    return registeredMenus;
  }
}
